module.exports = __webpack_public_path__ + "fonts/GT-America-Expanded-Bold.9d8ace66.woff";